import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import CalculateForm from "./calculateform"
import Campaign from "@smpu-web/nested/campaign"
import SssList from "./ssslist"
import Notes from "./notes"
import LandingHeader from "./landingheader"
import { useGetConfigListMutation } from "../../../api/services"
import { getCidParameter, getConfigValue, isNullOrEmpty, SMPUConfigListResponse } from "@smpu-web/utils/utils"

const Landing = () => {
  const [configList, setConfigList] = useState<SMPUConfigListResponse[]>();
  const [ilkEvim, setIlkEvim] = useState(getCidParameter()?.toLowerCase() === "ilk-evim")
  const [campaigns, setCampaigns] = useState();
  const [faqText, setFaqText] = useState();
  const [getConfigList] = useGetConfigListMutation();
  useEffect(() => {
    getConfigList({
      functionCode: "BKR0007",
      cid: getCidParameter() ?? "",
      TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setConfigList(payload.configList)
          if (!isNullOrEmpty(getConfigValue(payload.configList, "WebKonut.CampaignText.Landing.Top"))) {
            setCampaigns(JSON.parse(getConfigValue(payload.configList, "WebKonut.CampaignText.Landing.Top")))
          }
          if (!isNullOrEmpty(getConfigValue(payload.configList, "WebKonut.Landing.Faq"))) {
            setFaqText(JSON.parse(getConfigValue(payload.configList, "WebKonut.Landing.Faq")))
          }
        }
      })
  }, [])

  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <LandingHeader />
      <Grid type="main" className="landing-page-main">
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <CalculateForm ilkEvim={ilkEvim} configValues={configList} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Block className="text-section">
              <Element type="p" className="bold">
                {"Her Bütçeye Uygun Ev Kredisi Akbank’ta!"}
              </Element>
              <Element type="p" className="normal">
                {"Evinizi seçin, uygun ödeme koşullarıyla kira öder gibi ev sahibi olun!"}
              </Element>
            </Block>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            {campaigns && <Campaign data={campaigns} />}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            {faqText && <SssList faqText={faqText} />}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <Notes configValue={getConfigValue(configList, "WebKonut.CampaignText.Landing.Bottom")} />
          </Col>
        </Row>
      </Grid>
    </Block>
  )
}

export default Landing
